import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../../../../util/cookie/cookies";
import { Lang } from "./lang";

const Header_Moblie = () => {
    const lang = getCookie('HYUNDAILANG')
    const navigate = useNavigate()
    const location = useLocation()
    const [state, setState] = useState<boolean>(false)
    const [cookie, setCookie] = useCookies(['HYUNDAILANG'])
    const [langActive, setLangActive] = useState<boolean>(false)
    const { t, i18n } = useTranslation();
    const handleLangChangeKr =()=>{setCookie('HYUNDAILANG', 'kr' , {path : '/'}); i18n.changeLanguage('kr')}
    const handleLangChangeEn =()=>{setCookie('HYUNDAILANG', 'en', {path : '/'}); i18n.changeLanguage('en')}
    useEffect(()=>{
        setState(false)
    }, [location])
    return(
        <>
        <div className={state ? 'header_mo active' : 'header_mo'}>
            <div className="top active">
                <h1>
                    <span onClick={()=>navigate('/')}>
                        logo
                    </span>
                </h1>
                <button className="hamburger" onClick={()=>setState(prev => !prev)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
            <div className="nav">
                <ul>
                    <li>
                        <span>
                            <span>{lang==='kr'?'회사소개':'Compnay'}</span>
                            <span><img src="/assets/images/header_subArrow.png" alt="arrow"/></span>
                        </span>
                        <ul className="mo_sub_menu">
                            <li onClick={()=>navigate('/about/overView')}>
                                <span>{lang==='kr'?'회사개요':'Overview'}</span>
                            </li>
                            <li onClick={()=>navigate('/about/history')}>
                                <span>{lang==='kr'?'연혁':'History'}</span>
                            </li>
                            <li onClick={()=>navigate('/about/exportStatus')}>
                                <span>{lang==='kr'?'수출현황':'Export status'}</span>
                            </li>
                            <li onClick={()=>navigate('/about/business')}>
                                <span>{lang==='kr'?'사업장 소개':'Location'}</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <span>
                            <span><img src="/assets/images/liebherr_logo_sub.png" alt="liebherr logo"/></span>
                            <span><img src="/assets/images/header_subArrow.png" alt="arrow"/></span>
                        </span>
                        <ul className="mo_sub_menu">
                            <li onClick={()=>navigate('/liebherr/marineEngine')}>
                                <span>{lang==='kr'?'선박용 엔진':'Marine Engine'}</span>
                            </li>
                            <li onClick={()=>navigate('/liebherr/generatorEngine')}>
                                <span>{lang==='kr'?'발전기 엔진':'Generator Engine'}</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <span>
                            <span><img src="/assets/images/hyundai_logo_sub.png" alt="hyundai logo"/></span>
                            <span><img src="/assets/images/header_subArrow.png" alt="arrow"/></span>
                        </span>
                        <ul className="mo_sub_menu">
                            <li onClick={()=>navigate('/hyundai/marineEngine')}>
                                <span>{lang==='kr'?'선박용 엔진':'Marine Engine'}</span>
                            </li>
                            <li onClick={()=>navigate('/hyundai/generatorEngine')}>
                                <span>{lang==='kr'?'발전기 엔진':'Generator Engine'}</span>
                            </li>
                        </ul>
                    </li>
                    <li onClick={()=>navigate('/equipmentStatus')}>
                        <span>
                            <span>{lang==='kr'?'설비현황':'Facility status'}</span>
                        </span>
                    </li>
                    <li onClick={()=>navigate('/prCenter/news?type=ALL')}>
                        <span>
                            <span>{lang==='kr'?'홍보센터':'Promotion Center'}</span>
                        </span>
                    </li>
                    <li>
                        <span>
                            <span>{lang==='kr'?'고객센터':'Customer Center'}</span>
                            <span><img src="/assets/images/header_subArrow.png" alt="arrow"/></span>
                        </span>
                        <ul className="mo_sub_menu">
                            <li onClick={()=>navigate('/contact/inquiry')}>
                                <span>{lang==='kr'?'문의하기':'Contact Us'}</span>
                            </li>
                            <li onClick={()=>navigate('/contact/faq')}>
                                <span>FAQ</span>
                            </li>
                        </ul>
                    </li>
                </ul>
                <div className="rightBox">
                    <div className="langBox">
                        <button className={lang === 'kr' ? 'langBtn_ko active' : 'langBtn_ko'} onClick={handleLangChangeKr}>KO</button>
                        <button className={lang === 'en' ? 'langBtn_en active' : 'langBtn_en'} onClick={handleLangChangeEn}>EN</button>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Header_Moblie;